const TableNoRecords = () => {
	return (
		<tr>
			<td colSpan='20'>
				{' '}
				<div class='d-flex justify-content-center'>No Record Found</div>
			</td>
		</tr>
	);
};

export default TableNoRecords;
